define('services/serviceresources/serviceresource.service',['app'], function (app) {
    app.service('serviceresource', ['$http', '$rootScope', '$state', '$q', '$timeout', 'OpenOther', 'UserInfo', 'auiDialog', 'OpenUp', function ($http, $rootScope, $state, $q, $timeout, OpenOther, UserInfo, auiDialog, OpenUp) {
        var self = this,
            userId = '', // 存储 user 数据，避免所有用到 user 数据的方法都被传染成异步的，可读性太差
            lang = 'zh', // 卡片语言
            cacheKey = '', // 缓存 key，需要加上用户标识
            cacheCycle = 60 * 60 * 1000; // 缓存生命周期，单位：毫秒
        var leftMenuData;
        var index = location.protocol + "//" + location.host;
        var greyIdList;

        //数据模型
        $rootScope.cardData = {};

        // 工具箱
        this.utils = {
            // 对象深度对比方法
            deepCompare: function (x, y) {
                if (x === y) return true;
                if (!(x instanceof Object) || !(y instanceof Object)) return false;

                for (var p in x) {
                    if (!Object.prototype.hasOwnProperty.call(x, p)) continue;
                    if (!Object.prototype.hasOwnProperty.call(y, p)) return false;
                    if (x[p] === y[p]) continue;
                    if (typeof (x[p]) !== "object") return false;
                    if (!this.deepCompare(x[p], y[p])) return false;
                }

                for (p in y) {
                    if (Object.prototype.hasOwnProperty.call(y, p) && !Object.prototype.hasOwnProperty.call(x, p)) return false;
                }
                return true;
            }
        }

        // 初始化
        this.init = function (user, channel) {
            cacheKey = ':servicecard';
            if (user) {
                userId = user.id || user.memberUserID || user.userID;
            } else {
                userId = AUI.HDGWCall.getCookieOrSessionSt("x-uid");
            }

            cacheKey = userId + cacheKey;
            var defer = $q.defer();

            // 从缓存拿数据
            this.cache.getData(channel).then(function (res) {
                // 初始化数据模型
                self.data._data.data = res.data;
                self.data._data.expired = Date.now() + cacheCycle;

                // 初始化缓存
                self.cache.update();


                // 监视数据模型变化，刷新缓存
                $rootScope.$watch('cardData', function (nv, ov) {
                    if (nv && !self.utils.deepCompare(nv, ov)) {
                        self.cache.update();
                        $rootScope.$broadcast('cardsChanged');
                    }
                }, true);
                defer.resolve(res.data);
            });
            return defer.promise;
        }

        this.refresh = function (channel) {
            var defer = $q.defer();
            // 从缓存拿数据
            this.data.fetch(channel).then(function (res) {
                // 初始化数据模型
                self.data._data.data = res.data;
                self.data._data.expired = Date.now() + cacheCycle;
                // 刷新缓存
                self.cache.update();
                defer.resolve(res.data);
            });
            return defer.promise;
        }

        this.clearCache = function () {
            window.sessionStorage.removeItem(cacheKey);
        };

        this.setHdGrey = function (card) {
            var defer = $q.defer();
            var that = this;
            // 查看卡片灰度是否写入cookie
            if (!greyIdList) {
                OpenUp.getGreyCardConfig({req: {}}).then(function (data) {
                    greyIdList = data.greyCardList.map(function (item) {
                        return item.serviceID
                    });
                    that.newSetCookies(defer, card);
                })
            } else {
                this.newSetCookies(defer, card);
            }
            return defer.promise;
        };

        this.newSetCookies = function (defer, card) {
            var flag;
            if (!AUI.HDGWCall.getCookieOrSessionSt("x-hd-grey")) {
                flag = false
            } else if (AUI.HDGWCall.getCookieOrSessionSt("x-hd-grey").indexOf('sid' + card.cardItem + '-') === -1) {
                flag = true;
            } else {
                defer.resolve(true);
                return;
            }
            if (flag) {
                if (greyIdList.indexOf(card.cardItem) > -1) {
                    OpenUp.isGreyDeveloper({req: {serviceID: card.cardItem}}).then(function (data) {
                        if (data.greyType && data.greyType != 0) {
                            var newGreyType = AUI.HDGWCall.getCookieOrSessionSt("x-hd-grey") + '_' + 'sid' + card.cardItem + '-' + data.greyType;
                            AUI.HDGWCall.setCookie("x-hd-grey", newGreyType);
                        }
                        defer.resolve(true);
                    })
                } else {
                    defer.resolve(true);
                }
            } else {
                if (greyIdList.indexOf(card.cardItem) > -1) {
                    OpenUp.isGreyDeveloper({req: {serviceID: card.cardItem}}).then(function (data) {
                        if (data.greyType && data.greyType != 0) {
                            AUI.HDGWCall.setCookie("x-hd-grey", 'sid' + card.cardItem + '-' + data.greyType);
                        }
                        defer.resolve(true);
                    })
                } else {
                    defer.resolve(true);
                }
            }
        }

        // 缓存对象
        this.cache = {
            // 从缓存中取数据
            getData: function (channel) {
                var data,
                    defer = $q.defer();

                try {
                    data = JSON.parse(window.sessionStorage.getItem(cacheKey));
                } catch (e) {
                }

                // 没有缓存
                if (!data || !data.expired) {
                    return self.data.fetch(channel);
                }

                // 缓存超期
                if (data.expired < Date.now()) {
                    // 请求数据并更新缓存
                    self.data.fetch(channel).then(function (res) {
                        defer.resolve(res);
                    }, function (err) {
                        // 请求失败，使用旧数据
                        defer.resolve(data);
                    });
                } else {
                    // 缓存仍有效
                    $timeout(function () {
                        defer.resolve(data);
                    }, 1);
                }

                return defer.promise;
            },

            // 刷新缓存
            update: function () {
                if (!self.data._data.data || !userId) return;
                try {
                    window.sessionStorage.setItem(cacheKey, JSON.stringify(self.data._data));
                } catch (err) {
                    console.error(err);
                }

            }
        }

        // 数据对象
        this.data = {
            // 整体数据模型，利用 $rootScope 进行 watch 更新
            _data: $rootScope.cardData,
            //根据渠道不同，获取不同的数据源，channel : 80 联盟管理中心 81 合作伙伴用户中心,默认联盟管理中心
            fetch: function (channel) {
                if (channel == 81) {
                    return this.fetchPc();

                } else {
                    return this.fetchMc();
                }
            },

            //管理中心从服务端获取数据
            fetchMc: function () {
                var self_fetch = this,
                    defer = $q.defer();
                if (self_fetch._data && self_fetch._data.data && self_fetch._data.data.serviceCards) {
                    defer.resolve(self_fetch._data);
                    return defer.promise;
                }
                OpenOther.getResourceTree({
                    req: {
                        lang: lang
                    }
                }).then(function (result) {
                    if (!result.resourceTree) {
                        defer.reject();
                        return;
                    }
                    //遍历数组
                    var resourceTree = {
                        "reportCards": [],
                        "serviceCards": [],
                        "leftMenu": [],
                        "navigationMenu": [],
                        "accountCards":[],
                        "settingCards":[]
                    };

                    for (var i = 0; i < result.resourceTree.length; i++) {
                        if (result.resourceTree[i].classifyCode == "ReportDirectory") {
                            resourceTree.reportCards.push(result.resourceTree[i]);
                        }
                        if (result.resourceTree[i].itemCode == "MyAccount") {
                            resourceTree.accountCards=result.resourceTree[i].resourceTree.slice();
                        }
                        if (result.resourceTree[i].itemCode == "Settings") {
                            resourceTree.settingCards=result.resourceTree[i].resourceTree.slice();
                        }
                        if (result.resourceTree[i].classifyCode == "SERVICE_DIRECTORY") {
                            var hashList = angular.fromJson(result.resourceTree[i].hashList);
                            if (hashList && result.resourceTree[i].itemCode == 'AppService') {
                                hashList.push('#/myServiceListPay');
                                hashList.push('#/myServiceListId');
                                hashList.push('#/incentive');
                                result.resourceTree[i].hashList = angular.toJson(hashList);
                            }
                            resourceTree.serviceCards.push(result.resourceTree[i]);
                        }
                        if (result.resourceTree[i].classifyCode == "NavigationMenu") {
                            resourceTree.navigationMenu.push(result.resourceTree[i]);
                        }

                        if (result.resourceTree[i].classifyCode == "LeftMenu") {
                            var leftMenuOne = result.resourceTree[i];
                            if (leftMenuOne && leftMenuOne.resourceTree && leftMenuOne.resourceTree.length > 0) {
                                for (var y = 0; y < leftMenuOne.resourceTree.length; y++) {
                                    if (leftMenuOne.resourceTree[y].itemCode == "Banlance") {
                                        leftMenuOne.resourceTree[y].hashList = leftMenuOne.resourceTree[y].hashList + ',balance'
                                    }
                                    leftMenuOne.resourceTree[y].hashList = leftMenuOne.resourceTree[y].hashList.split(",");
                                }
                            }
                            resourceTree.leftMenu.push(leftMenuOne);
                        }

                    }
                    resourceTree.navigationMenu.sort(function (a, b) {
                        return a.itemIndex - b.itemIndex
                    });
                    self_fetch._data.data = resourceTree;
                    self_fetch._data.expired = Date.now() + cacheCycle;
                    //卡片灰度上线功能
                    self.grayscale.replaceGrayscale(self_fetch);
                    defer.resolve(self_fetch._data)
                }, function (err) {
                    defer.reject(err);
                });
                return defer.promise;
            },
            //合作伙伴中心从服务端获取数据
            fetchPc: function () {
                var self_fetch = this,
                    defer = $q.defer();

                OpenOther.getPartnerCentResourceTree({
                    req: {
                        lang: lang
                    }
                }).then(function (result) {
                    if (!result.resourceTree) {
                        defer.reject();
                        return;
                    }
                    //遍历数组
                    var resourceTree = {
                        "leftMenu": [],
                        "navigationMenu": []
                    };

                    for (var i = 0; i < result.resourceTree.length; i++) {
                        if (result.resourceTree[i].classifyCode == "LeftMenu") {
                            var leftMenuOne = [];
                            leftMenuOne = result.resourceTree[i];
                            if (leftMenuOne.resourceTree && leftMenuOne.resourceTree.length > 0) {
                                for (var y = 0; y < leftMenuOne.resourceTree.length; y++) {
                                    leftMenuOne.resourceTree[y].hashList = leftMenuOne.resourceTree[y].hashList.split(",");
                                }
                            }
                            resourceTree.leftMenu.push(leftMenuOne);
                        }
                        if (result.resourceTree[i].classifyCode == "NavigationMenu") {
                            resourceTree.navigationMenu.push(result.resourceTree[i]);
                        }
                    }
                    resourceTree.navigationMenu.sort(function (a, b) {
                        return a.itemIndex - b.itemIndex
                    });
                    self_fetch._data.data = resourceTree;
                    self_fetch._data.expired = Date.now() + cacheCycle;
                    defer.resolve(self_fetch._data)
                }, function (err) {
                    defer.reject(err);
                });
                return defer.promise;
            },

        }

        //卡片灰度上线
        this.grayscale = {
            //替换灰度配置文件
            replaceGrayscale: function (self_fetch) {
                if (grayscaleCfg && grayscaleCfg.cards) {
                    //遍历配置文件
                    grayscaleCfg.cards.forEach(function (v) {
                        //配置文件包含当前userid
                        if (v.userIdList && v.userIdList.length > 0 && v.userIdList.indexOf(userId) !== -1) {
                            self.grayscale.replaceCardDate(v, self_fetch);
                        }
                    });
                }
            },
            //替换卡片数据
            replaceCardDate: function (v, self_fetch) {

                for (var i = 0, source = self_fetch._data.data[v.cardType]; i < source.length; i++) {
                    for (var j = 0, categorys = source[i].resourceTree; j < categorys.length; j++) {
                        for (var k = 0, cards = categorys[j].cards; k < cards.length; k++) {
                            if (cards[k].cardItem == v.cardItem) {
                                if (v.data['cn'] && v.data['cn'].url) {
                                    cards[k].link.url = v.data['cn'].url;
                                }
                                if (v.data['cn'] && v.data['cn'].target) {
                                    cards[k].link.target = v.data['cn'].target;
                                }

                            }
                        }
                    }
                }
            }

        }

        // 菜单对象
        this.menu = {
            // 获取服务卡片菜单
            getServiceCardMenu: function () {
                var data = self.data._data.data;
                return data ? data.serviceCards : [];
            },

            // 获取报表卡片菜单
            getReportCardMenu: function () {
                var data = self.data._data.data;
                return data ? data.reportCards : [];
            },

            // 获取我的账户卡片菜单
            getAccountCardMenu: function () {
                var data = self.data._data.data;
                return data ? data.accountCards : [];

            },

            // 获取报表卡片菜单
            getMySettingMenu: function () {
                var data = self.data._data.data;
                return data ? data.settingCards : [];
            },

            //获取左侧菜单
            getLeftMenu: function () {
                leftMenuData = (leftMenuData ? leftMenuData : self.data._data.data);
                if (!leftMenuData) {
                    var key = "";
                    var userId = AUI.HDGWCall.getCookieOrSessionSt("x-teamId") || AUI.HDGWCall.getCookieOrSessionSt("x-uid");
                    key = userId + ':servicecard';
                    if (window.sessionStorage.getItem(key)) {
                        leftMenuData = JSON.parse(window.sessionStorage.getItem(key)).data;
                    }
                }
                return leftMenuData ? leftMenuData.leftMenu : [];
            },

            //获取右上角导航菜单
            getNavigationMenu: function () {
                var data = self.data._data.data;
                return data ? data.navigationMenu : [];
            },

            //校验CP有没有菜单权限
            checkleftMenu: function (name, channel) {
                var defer = $q.defer();
                self.menu.getleftMenu(name, channel).then(function (leftMenu) {
                    var leftMenuHashList = [];
                    var checkleftMenuCp = false;
                    leftMenu.forEach(function (item) {
                        if (item.resourceTree && item.resourceTree.length != 0) {
                            item.resourceTree.forEach(function (menu) {
                                if (Object.prototype.toString.call(menu.hashList) === '[object Array]') {
                                    menu.hashList.forEach(function (hashlist) {
                                        leftMenuHashList.push(hashlist);
                                    })
                                } else {
                                    leftMenuHashList.push(menu.hashList);
                                }
                            })
                        } else {
                            leftMenuHashList.push(item.hashList)
                        }
                    });
                    leftMenuHashList.forEach(function (item) {
                        if (name.indexOf(item) != -1) {
                            checkleftMenuCp = true;
                        }
                    });
                    defer.resolve(checkleftMenuCp);
                }).catch(function () {
                    defer.resolve(false);
                });
                return defer.promise;
            },
            getleftMenu: function (name, channel) {
                var defer = $q.defer();
                if (AUI.HDGWCall.getUserInfoValue('teamid')) {
                    userId = AUI.HDGWCall.getUserInfoValue('teamid');
                } else {
                    userId = AUI.HDGWCall.getCookieOrSessionSt('x-uid')
                }
                var key = userId + ":servicecard";
                var allData = JSON.parse(window.sessionStorage.getItem(key));
                if (allData) {
                    defer.resolve(allData.data ? allData.data.leftMenu : []);
                } else {
                    if (channel && channel == 81) {
                        self.data.fetchPc().then(function (data) {
                            if (data && data.data && data.data.leftMenu) {
                                defer.resolve(data.data.leftMenu);
                            } else {
                                defer.resolve([]);
                            }
                        });
                    } else {
                        self.data.fetchMc().then(function (data) {
                            if (data && data.data && data.data.leftMenu) {
                                defer.resolve(data.data.leftMenu);
                            } else {
                                defer.resolve([]);
                            }
                        })
                    }
                }
                return defer.promise;
            }

        }

        // 卡片对象
        this.cards = {
            // 点击卡片
            click: function (card, event) {
                // 点击角标时不要跳转卡片
                if (event.target.tagName === 'A') return;

                // 预发布的卡片不跳转
                if (card.isPrePublish === 'true') return;

                // 空地址不跳转
                if (!card.link.url) return;

                // 无打开权限时给出提示
                if (card.hasPermission === 'false') {
                    auiDialog.warn(card.serviceMsg);
                    return;
                }

                // 如果点击的是 new 卡片
                if (card.isNew === 'true') {
                    // 取消界面上 new 标识
                    card.isNew = 'false';

                    // 发请求置为非 new
                    this.removeNew(card);
                }

                // 打开卡片
                this.open(card);
            },

            // 打开卡片链接
            open: function (card) {
                // 卡片跳转，支持 hash 模式：#/xxx
                switch (card.link.target) {
                    case '_self':
                        if (/^#\/.+$/i.test(card.link.url)) {
                            AUI.BaseJSUtil.redirectUrl(window.location.href.replace(/#\/.+$/i, card.link.url));
                        } else {
                            if (card.link.url.indexOf('http') > -1) {
                                AUI.BaseJSUtil.redirectUrl(card.link.url);
                            } else {
                                AUI.BaseJSUtil.redirectUrl(index + card.link.url);
                            }
                        }
                        break;
                    case '_blank':
                        if (AUI.BaseJSUtil.getSafeUrl(card.link.url)) {
                            AUI.BaseJSUtil.redirectUrlByBlank(AUI.BaseJSUtil.getSafeUrl(card.link.url));
                        } else {
                            //处理相对路径
                            AUI.BaseJSUtil.redirectUrlByBlank(index + card.link.url);
                        }
                        break;
                    case 'iframe':
                    default:
                        $state.go('openCard', {dirId: card.directoryId, cardId: card.cardItem});
                }
            },

            // 去除 new 标识
            removeNew: function (card) {
                OpenOther.cancelCardNew({
                    req: {
                        serviceItem: card.cardItem
                    }
                }).then(function (res) {
                    // TODO
                }, function (err) {
                    // 请求失败还原数据
                    card.isNew = 'true';
                });
            },

            // 获取卡片，服务卡片和报表卡片一起查找
            getCard: function (dirId, cardItem) {
                var data = self.data._data.data;
                if (!data || !dirId || !cardItem) return;
                for (var i = 0, all = data.serviceCards.concat(data.reportCards); i < all.length; i++) {
                    if (dirId === all[i].itemCode) {
                        for (var j = 0, resourceTree = all[i].resourceTree; j < resourceTree.length; j++) {
                            for (var k = 0, cards = resourceTree[j].cards; k < cards.length; k++) {
                                if (cards[k].cardItem === cardItem) return cards[k];
                            }
                        }
                    }
                }
            },

            // 获取全部服务卡片
            getAllServiceCards: function () {
                var data = self.data._data.data;
                if (!data) return;

                return data.serviceCards;
            },

            // 获取全部报表卡片
            getAllReportCards: function () {
                var data = self.data._data.data;
                if (!data) return;

                return data.reportCards;
            },

            // 获取服务卡片
            getServiceCards: function (dirId) {
                var data = self.data._data.data;
                if (!data) return;

                return this._getCards(data.serviceCards, dirId);
            },

            // 获取报表卡片
            getReportCards: function (dirId) {
                var data = self.data._data.data;
                if (!data) return;

                return this._getCards(data.reportCards, dirId);
            },

            // 获取首页菜单，即第一个有卡片的目录
            getHomeDir: function () {
                var data = self.data._data.data;
                if (!data) return;

                for (var i = 0, dirs = data.serviceCards || []; i < dirs.length; i++) {
                    var hasCards = self.customizer.hasCustomizedServiceCards(dirs[i].itemCode);
                    if (hasCards) return dirs[i];
                }
            },

            // 获取卡片
            // 不指定目录时返回第一个有定制卡片的目录，用于首页
            _getCards: function (dirs, dirId) {
                if (!dirs || !dirs.length) return;

                for (var i = 0; i < dirs.length; i++) {
                    // 第一个有卡片的目录（未指定目录时）或者指定的目录
                    var hasCards = self.customizer.hasCustomizedServiceCards(dirs[i].itemCode);
                    if (!dirId && hasCards || dirs[i].itemCode === dirId) return dirs[i].resourceTree;
                }
            }
        }

        // 定制器
        this.customizer = {
            // 定制/取消卡片
            customize: function (card) {
                card.isSelected = card.isSelected === 'N' ? 'Y' : 'N';

                // 不允许全部取消定制
                if (!this.hasCustomizedServiceCards()) {
                    card.isSelected = 'Y';
                    return;
                }

                // 发送数据
                OpenOther.saveUserDefinedCardData({
                    req: {
                        serviceItem: card.cardItem,
                        isSelected: card.isSelected
                    }
                }, function (data) {
                    // TODO
                }, function (err) {
                    // 请求失败则还原数据
                    card.isSelected = card.isSelected === 'N' ? 'Y' : 'N';
                });
            },

            // 判断是否定制了服务卡片
            hasCustomizedServiceCards: function (dirId) {
                var data = self.data._data.data;
                if (!data || !data.serviceCards) return;

                for (var i = 0, resourceTreeParent = data.serviceCards; resourceTreeParent && i < resourceTreeParent.length; i++) {
                    if (dirId && resourceTreeParent[i].itemCode !== dirId) continue;
                    for (var j = 0, resourceTree = resourceTreeParent[i].resourceTree; resourceTree && j < resourceTree.length; j++) {
                        for (var k = 0, cards = resourceTree[j].cards; k < cards.length; k++) {
                            if (cards[k].isSelected == 'Y') return true;
                        }
                    }
                }

                return false;
            },

            // 判断是否定制了报表卡片
            // 报表暂无订制功能，有报表就算
            hasCustomizedReportCards: function (dirId) {
                var data = self.data._data.data;
                if (!data || !data.reportCards) return;

                for (var i = 0, resourceTreeParent = data.reportCards; i < resourceTreeParent.length; i++) {
                    if (dirId && resourceTreeParent[i].itemCode !== dirId) continue;
                    for (var j = 0, resourceTree = resourceTreeParent[i].resourceTree; j < resourceTree.length; j++) {
                        if (resourceTree[j].cards.length) return true;
                    }
                }

                return false;
            },

            // 判断是否定制了报表卡片
            // 报表暂无订制功能，有报表就算
            hasCustomizedReportCards: function (dirId) {
                //检查集合中根据么个属性是否重复
                function contains(arr, attr, value) {
                    var found = false;
                    for (var i = 0; !!arr && arr.length && i < arr.length; i++) {
                        if (arr[i][attr + ""] == value) {
                            found = true;
                            break;
                        }
                    }
                    return found;
                }

                var data = self.data._data.data;
                if (!data || !data.serviceCards) return;
                if (!data || !data.reportCards) return;
                //获取定制的服务
                var allServiceCards = [];
                //过去定制的报表卡片
                var selectedReports = [];
                //所有的报表卡片
                var allReports = [];
                for (var i = 0, directorys = data.serviceCards; i < directorys.length; i++) {
                    for (var j = 0, categorys = directorys[i].resourceTree; j < categorys.length; j++) {
                        for (var k = 0, cards = categorys[j].cards; k < cards.length; k++) {
                            //防止重复
                            if (!contains(allServiceCards, "cardIndex", cards[k].cardIndex)) {
                                allServiceCards[allServiceCards.length] = cards[k];
                            }
                        }
                    }
                }
                //查询所有报表卡片
                for (var i = 0, directorys = data.reportCards; i < directorys.length; i++) {
                    if (dirId && directorys[i].itemCode !== dirId) continue;
                    for (var j = 0, categorys = directorys[i].resourceTree; j < categorys.length; j++) {
                        for (var k = 0, reportCards = categorys[j].cards; k < reportCards.length; k++) {
                            //防止重复
                            if (!contains(allReports, "cardIndex", reportCards[k].cardIndex)) {
                                allReports[allReports.length] = reportCards[k];
                            }
                        }
                    }
                }
                //根据定制的服务关联报表卡片，设置报表卡片的显示属性
                for (var i = 0; i < allReports.length; i++) {
                    //默认全部显示
                    allReports[i].isShow = true;
                    //找到对应的报表卡片，如果服务卡片没选中，则不显示
                    for (var j = 0; j < allServiceCards.length; j++) {
                        if (allReports[i].cardIndex == allServiceCards[j].cardIndex && allServiceCards[j].isSelected != 'Y') {
                            allReports[i].isShow = false;
                            break;
                        }
                    }
                    allReports[i].isShow && (selectedReports[selectedReports.length] = allReports[i]);
                }

                return selectedReports && selectedReports.length > 0;
            },

            // 判断是否存在未定制的 New 服务卡片
            hasUncustomizedNewServiceCards: function (dirId, cateId) {
                var data = self.data._data.data,
                    homeDir = self.cards.getHomeDir();

                if (!data || !data.serviceCards || !homeDir) return;

                dirId = dirId || homeDir.itemCode;

                for (var i = 0, resourceTreeParent = data.serviceCards; i < resourceTreeParent.length; i++) {
                    if (resourceTreeParent[i].itemCode === dirId) {
                        for (var j = 0, resourceTree = resourceTreeParent[i].resourceTree; j < resourceTree.length; j++) {
                            if (resourceTree[j].itemCode === cateId) {
                                for (var k = 0, cards = resourceTree[j].cards; k < cards.length; k++) {
                                    if (cards[k].isSelected === 'N' && cards[k].isNew === 'true') return true;
                                }
                            }
                        }
                    }
                }

                return false;
            }
        }
    }]);
});

